import { createClient } from '@supabase/supabase-js';

// Initialize the Supabase client
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Only log in development, not in production
if (process.env.NODE_ENV === 'development') {
  console.log('Supabase URL:', supabaseUrl);
  console.log('Supabase Key exists:', !!supabaseAnonKey);
}

// Create Supabase client with error handling
let supabase;
try {
  if (supabaseUrl && supabaseAnonKey) {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
  } else {
    // Create a mock client if env vars are missing to prevent runtime errors
    if (process.env.NODE_ENV === 'development') {
      console.warn('Supabase credentials not found. Some features may not work.');
    }
    supabase = {
      from: () => ({
        insert: () => Promise.resolve({ error: { message: 'Supabase not configured' } })
      })
    };
  }
} catch (error) {
  // Silently handle Supabase initialization errors - don't show popups
  if (process.env.NODE_ENV === 'development') {
    console.warn('Error initializing Supabase:', error);
  }
  // Create a mock client to prevent runtime errors
  supabase = {
    from: () => ({
      insert: () => Promise.resolve({ error: { message: 'Supabase initialization failed' } })
    })
  };
}

export { supabase };
